import { isLimitedDevice } from '@/utils/limited-device';
import type { PerformanceTracingConfig } from '@/contexts/dynamic-config';

export interface PerformanceTracingRuntimeConfig {
  emitStartEvents: boolean;
  enabled: boolean;
  sampleRate: number;
}

export const DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG: PerformanceTracingRuntimeConfig =
  {
    emitStartEvents: true,
    enabled: false,
    sampleRate: 0,
  };

let _config = DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG;

export const performanceTracingRuntimeConfig = {
  get: (): PerformanceTracingRuntimeConfig => _config,
  reset: () => {
    _config = DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG;
  },
  set: (config: PerformanceTracingRuntimeConfig) => {
    _config = config;
  },
};

const normalizeSampleRate = (sampleRate?: number | null) => {
  if (
    typeof sampleRate !== 'number' ||
    Number.isNaN(sampleRate) ||
    sampleRate < 0 ||
    sampleRate > 1
  ) {
    return DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG.sampleRate;
  }

  return sampleRate;
};

export const resolvePerformanceTracingRuntimeConfig = (
  config?: PerformanceTracingConfig | null,
  limitedAppEnabled = false,
): PerformanceTracingRuntimeConfig => ({
  emitStartEvents:
    config?.emit_start_events ??
    DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG.emitStartEvents,
  enabled:
    !(limitedAppEnabled && isLimitedDevice()) &&
    Boolean(
      config?.enabled ?? DEFAULT_PERFORMANCE_TRACING_RUNTIME_CONFIG.enabled,
    ),
  sampleRate: normalizeSampleRate(config?.sample_rate),
});

export const shouldSamplePerformanceTrace = (sampleRate: number) =>
  Math.random() < sampleRate;
